import Col from 'react-bootstrap/lib/Col'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import Row from 'react-bootstrap/lib/Row'
import format from 'date-fns/format'
import {css} from 'glamor'

import Badge from '../../../../components/badge'
import ComfortSlider from './comfortSlider'
import SizeFitSlider from './sizeFitSlider'
import Stars from '../../../../components/stars'
import {colors, text} from '../../../../styles'

const style = {
  badge: css({
    marginBottom: '5px'
  }),
  body: css(text.bodySmall, {
    marginBottom: '5px'
  }),
  container: css({
    borderBottom: `1px solid ${colors.grayLighter}`,
    padding: '15px 0',
    '@media (max-width: 767px)': {
      margin: '0 -15px',
      padding: '15px'
    }
  }),
  date: css({
    margin: '2px 0 5px'
  }),
  helpful: css(text.bodySmall, {
    color: colors.grayLight,
    marginBottom: '20px'
  }),
  stars: css(text.icon, {
    marginBottom: '5px'
  }),
  slider: css({
    marginBottom: '20px'
  }),
  title: css(text.bodyHeader, {
    lineHeight: '20px'
  })
}

class Review extends PureComponent {
  render() {
    const {review} = this.props
    return (
      <div {...style.container}>
        <Row>
          <Col sm={12}>
            <div {...style.stars}>
              <Stars rating={review.StarRating} />
            </div>
            <div {...style.date}>
              {format(review.RatingDate, 'MMM DD, YYYY')}
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <div {...style.badge}>
              {review.WasReviewHelpful > 3 && review.MemberID !== 182 && (
                <Badge>Top Reviewer</Badge>
              )}
              {review.MemberID == 182 && (
                <Badge kind="important">Prep Sportswear</Badge>
              )}
            </div>
            <div {...style.title}>{review.ReviewTitle}</div>
            <div {...style.body}>{review.TextReview}</div>
            <div {...style.helpful}>
              {review.WasReviewHelpful} people thought this review was helpful
            </div>
          </Col>
          <Col xs={12} sm={6} md={3} mdPush={2}>
            <div className="fitComfort">
              <div {...style.slider}>
                <SizeFitSlider value={review.OverallFit || 0} />
              </div>
              <div {...style.slider}>
                <ComfortSlider value={review.Comfort} />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

Review.propTypes = {
  review: PropTypes.object.isRequired
}

export default Review
